import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Plus, Minus, X } from "lucide-react";
import { cn } from "@/lib/utils";

interface BulkActionsToolbarProps {
  selectedCount: number;
  onClearSelection: () => void;
  onAddLabels: () => void;
  onRemoveLabels: () => void;
}

export function BulkActionsToolbar({
  selectedCount,
  onClearSelection,
  onAddLabels,
  onRemoveLabels,
}: BulkActionsToolbarProps) {
  if (selectedCount === 0) return null;

  return (
    <div className={cn(
      "fixed bottom-4 left-1/2 -translate-x-1/2 z-50",
      "bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80",
      "border rounded-lg shadow-lg p-3",
      "flex items-center gap-4 flex-wrap",
      "animate-in slide-in-from-bottom-5 duration-300"
    )}>
      <div className="flex items-center gap-2">
        <Badge variant="secondary" className="px-3 py-1">
          {selectedCount} selected
        </Badge>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClearSelection}
          className="h-8"
        >
          <X className="h-4 w-4 mr-1" />
          Clear
        </Button>
      </div>
      
      <div className="h-6 w-px bg-border" />
      
      <div className="flex gap-2">
        <Button
          variant="default"
          size="sm"
          onClick={onAddLabels}
          className="h-8"
        >
          <Plus className="h-4 w-4 mr-1" />
          Add Labels
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={onRemoveLabels}
          className="h-8"
        >
          <Minus className="h-4 w-4 mr-1" />
          Remove Labels
        </Button>
      </div>
    </div>
  );
}
